import type { CSSProperties } from 'react';
import { forwardRef, useState, useRef } from 'react';
import { Picture } from '@ui';
import useOutsideAlerter from '@customHooks/useOutsideAlerter';
import UIicons from '@ui-kit';
import './index.scss';
import { capitalizeFirstLetter } from '@utils/capitalizeFirstLetter';
const { chevronLeftLightGrey } = UIicons;

export type SelectListT = Array<{
  value: number | string;
  label: string;
}>;

interface SelectProps {
  activeValue: number | string | null | undefined;
  passiveTitle?: string;
  list: SelectListT;
  field;
  className?: string;
  style?: CSSProperties;
  classNameSelect?: string;
  callback: (field: string, value: any) => void;
}

const Select = forwardRef<HTMLDivElement | null, SelectProps>(
  (
    {
      activeValue,
      passiveTitle,
      list,
      field,
      className,
      style,
      classNameSelect,
      callback
    },
    ref
  ) => {
    const [isDisplayMenu, setIsDisplayMenu] = useState(false);
    const dropdownRef = useRef<HTMLUListElement>(null);
    useOutsideAlerter({
      ref: dropdownRef,
      callback: () => {
        setIsDisplayMenu(false);
      }
    });

    const showDropdownMenu = (): void => {
      setIsDisplayMenu(!isDisplayMenu);
    };
    const hideDropdownMenu = (): void => {
      setIsDisplayMenu(false);
    };
    const filtered = list?.find(item => item.value === activeValue) || {
      label: 'Не выбрано'
    };
    const activeTitle = capitalizeFirstLetter(filtered?.label || '');
    return (
      <>
        {passiveTitle && (
          <div className='dropdown-select-title'>{passiveTitle}</div>
        )}
        <div ref={ref} className={`dropdown-select ${classNameSelect || ''}`}>
          <div
            className={`button ${className || ''}`}
            onClick={showDropdownMenu}
          >
            {activeTitle}
            <Picture
              className={`dropdown-select__arrow${
                isDisplayMenu ? ' dropdown-select__arrow--active' : ''
              }`}
              icon={chevronLeftLightGrey}
              height='24'
            />
          </div>
          {isDisplayMenu && (
            <ul ref={dropdownRef} className={className}>
              {list.map(item => {
                const title = capitalizeFirstLetter(item.label || '');
                return (
                  <li
                    className={item.value === activeValue ? 'active' : ''}
                    style={style || {}}
                    key={item.value}
                    onClick={() => {
                      callback(field, item.value);
                      hideDropdownMenu();
                    }}
                  >
                    <span>{title}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </>
    );
  }
);

export default Select;
